import { BadgesIconListFragment } from '@graphqlTypes/sitecore';
import { withFullPath } from '@src/common/path-convert';
import { memo } from 'react';

interface Props {
    badgeIconData: BadgesIconListFragment[] | [];
    className?: string;
}

/** 徽章说明 */
const BadgeDescription = (props: Props) => {
    return (
        <div className={`${props?.className} flex-1`}>
            {props.badgeIconData.length > 0 &&
                props.badgeIconData.map((i, index: number) => (
                    <div className={`flex mb-1 items-center`} key={index}>
                        <img
                            className='w-[16px] h-[16px] mr-1'
                            src={withFullPath(i.badgeIconImage?.src || '')}
                            alt=''
                            loading='lazy'
                        />
                        <div className='text-[11px] text-black font-normal'>
                            {i.badgeText?.value || ''}
                        </div>
                    </div>
                ))}
        </div>
    );
};

export default memo(BadgeDescription);
